module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ihFHo"))).then(() => parcelRequire('fThBo'));